/* Utilities JS: Universal helper functions */

// Get width of scrollbar, set to custom property
const getScrollbarWidth = () => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    return scrollbarWidth;
}

// Smooth scrolling between page elements
const smoothScroll = (target, dest) => {
    target.addEventListener('click', e => {
        e.preventDefault();
        const dest = document.querySelector(`[name='${target.dataset.scrolltarget}']`) || document.querySelector('body');
        dest.scrollIntoView({ 
            behavior: 'smooth' 
        });
        dest.focus();
    });
}

// Detect when an element is being sticky, add class when true
const isStuck = el => {
    const observer = new IntersectionObserver( ([e]) => {
        el.classList.toggle('stuck', e.intersectionRatio < 1);
    }, { threshold: [1] });
    observer.observe(el);
}
